export default {
  methods: {
    loginCheck() {
      if (!this.$store.state.user) {
        this.$message.error('请先登录')
        this.$router.push({
          name: 'login',
          query: {
            redirect: this.$route.fullPath
          }
        })

        return false
      }

      return true
    }
  }
}
